import { createAction } from 'redux-actions';

import { CLEAR_CLIENT_PROFILE_ENTRIES } from '../../types';

export const clearProfileDetailsEntries = createAction(CLEAR_CLIENT_PROFILE_ENTRIES);


// WEBPACK FOOTER //
// ./src/features/client-profile/actions/clearActions/clearProfileDetailsEntriesActions.js